// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3N12f","content":"styles_content__29IWL","selectAll":"styles_selectAll__tnchc"};